import { render, staticRenderFns } from "./NodeInstallation.vue?vue&type=template&id=868f6d2e&scoped=true&"
import script from "./NodeInstallation.vue?vue&type=script&lang=js&"
export * from "./NodeInstallation.vue?vue&type=script&lang=js&"
import style0 from "./NodeInstallation.vue?vue&type=style&index=0&id=868f6d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f6d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('868f6d2e')) {
      api.createRecord('868f6d2e', component.options)
    } else {
      api.reload('868f6d2e', component.options)
    }
    module.hot.accept("./NodeInstallation.vue?vue&type=template&id=868f6d2e&scoped=true&", function () {
      api.rerender('868f6d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Node/NodeInstallation.vue"
export default component.exports